import React, { useEffect, useState, Fragment, useRef } from 'react';
import { PageHeader } from '../../../../Common';
import { DailyCollectionReportContent } from '../../../Common/Table/tableContent';
import services from '../services';
import InputLabel from '@material-ui/core/InputLabel';
import $ from 'jquery';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import FormHelperText from '@material-ui/core/FormHelperText';
import Joi, { x } from '@hapi/joi';
import { LoadingSpinerComponent } from '../../../../Common/loader'
import { trackPromise } from 'react-promise-tracker';
import authService from '../../../Common/services';
import tokenService from '../../../../Common/tokenDecoder';
import ReactToPrint from "react-to-print";
import { CSVLink, CSVDownload } from "react-csv";
import TextField from '@material-ui/core/TextField';
import { DailyCollectionCategoryObject } from '../DailyCollectionCategorySchema';
import { validateProperty, validate } from "../../../Common";
import CreatePdf from './createPdf';
import { forIn } from 'lodash';
import '../Pages/tableFooter.css';
import xlsx from 'json-as-xlsx';
import _ from 'lodash';

const screenCode = 'DAILYCOLLECTIONREPORT';

export function DailyCollectionListing(props) {

    const componentRef = useRef();

    const [groups, setGroups] = useState();
    const [factories, setFactories] = useState();
    const [routes, setRoutes] = useState();
    const [count, setCount] = useState(0);
    const [errors, setErrors] = useState({})
    const options = {
        orientation: 'landscape',
        unit: 'in',
        format: [1070, 700]
    };

    const schema = Joi.object(DailyCollectionCategoryObject).options({ allowUnknown: true })
    const pdfRef = useRef(null);

    const [collectionCategoryReport, setcollectionCategoryReport] = useState([])
    const [isReportButtonsEnabled, setIsReportButtonsEnabled] = useState(false);
    const [detailDeductions, setDetailDeductions] = useState({});
    const [deductionNamesForSummary, setDeductionNamesForSummary] = useState([]);
    const [totalSummaryRow, setTotalSummaryRow] = useState([]);
    const [searchForm, setSearchForm] = useState(
        {
            groupID: "0",
            routeID: "0",
            factoryID: "0",
            searchdate: new Date().toISOString().split("T")[0],
            toDate: new Date().toISOString().split("T")[0]
        }
    );

    const [selectedSearchValues, setSelectedSearchValues] = useState({
        group: "",
        route: "",
        factory: "",
        date: "",
        toDate: ""
    })

    const [contentRowNames, setContentRowNames] = useState(["customerFullName", "date", "startTime", "collectionTypeName", "tagNumber", "registrationNumber", "narration", "actualAmount", "grossAmount",
        "netAmount", "factualAmount", "fGrossAmount", "fNetAmount", "grossVariance", "lossGain"])
    const [isTableHide, setIsTableHide] = useState(true);
    const [excelData, setExcelData] = useState([]);
    const [deductionTypeNamesOfTable, setDeductionTypeNamesOfTable] = useState([]);
    const [feildAvailabeDedauctionTypes, setFeildAvailabeDedauctionTypes] = useState([]);
    const [weighAvailabeDedauctionTypes, setWeighAvailabeDedauctionTypes] = useState([]);
    const [weighDedauctionTypesTable, setWeighDedauctionTypesTable] = useState([]);
    const [footerTotalRowExcel, setFooterTotalRowExcel] = useState([]);
    const [permissionList, setPermissions] = useState({
        isGroupFilterEnabled: false,
        isOperationEntityFilterEnabled: false,
        isVarianceColumnEnabled: false,
        isActulaAmountColumnEnabled: false
    });
    const [mobileSessionKeys, setMobileSessionKeys] = useState([]);
    const initialContentRowNames = ["customerFullName", "date", "startTime", "collectionTypeName", "tagNumber", "registrationNumber", "narration", "grossAmount",
        "netAmount", "fGrossAmount", "fNetAmount", "grossVariance", "lossGain"];
    const initlaCsvHeaders = [
        { label: "Customer Name", value: "customerFullName" },
        { label: "Date", value: "date" },
        { label: "Time", value: "startTime" },
        { label: "Collection Type", value: "collectionTypeName" },
        { label: "Tag Number", value: "tagNumber" },
        { label: "Registration Number", value: "registrationNumber" },
        { label: "Narration", value: "narration" },
        { label: "Field Gross Amount (Kg)", value: "grossAmount" },
        { label: "Field Net Amount (Kg)", value: "netAmount" },
        { label: "Factory Gross Amount (Kg)", value: "fGrossAmount" },
        { label: "Factory Net Amount (Kg)", value: "fNetAmount" },
        { label: "Gross Variance", value: "grossVariance" },
        { label: "Loss/Gain", value: "lossGain" },
    ];
    const [csvHeaders, setCsvHeaders] = useState([]);

    const [detailCard, setDetailCard] = useState({});

    useEffect(() => {
        getPermissions();
    }, []);

    useEffect(() => {
        trackPromise(
            getEsatesForDropDown(),
            getDeductionTypesForTable()
        )
    }, [searchForm.groupID])

    useEffect(() => {
        trackPromise(
            GetAllRoutesForDropDown()
        )
    }, [searchForm.factoryID])

    useEffect(() => {
        destroyDataTable();
        createDataTable();
    }, [collectionCategoryReport])

    async function getPermissions() {
        var permissions = await authService.getPermissionsByScreen(screenCode);
        var isAuthorized = permissions.find(p => p.permissionCode == 'DAILYCOLLECTIONREPORT');

        if (isAuthorized === undefined) {
            props.history.push('/unauthorized');
        }

        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
        var isOperationEntityFilterEnabled = permissions.find(p => p.permissionCode == 'OPERATIONENTITYDROPDOWN');
        var isVarianceColumnEnabled = permissions.find(p => p.permissionCode == 'VARIANCECOLUMN');
        var isActulaAmountColumnFilterEnabled = permissions.find(p => p.permissionCode == 'VIEWACTUALAMOUNTCOULMN');

        setPermissions({
            ...permissionList,

            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isOperationEntityFilterEnabled: isOperationEntityFilterEnabled !== undefined,
            isVarianceColumnEnabled: isVarianceColumnEnabled !== undefined,
            isActulaAmountColumnEnabled: isActulaAmountColumnFilterEnabled != undefined
        });

        var token = tokenService.getUserDetailsFromToken();
        setSearchForm({
            ...searchForm,
            groupID: token.groupID,
            factoryID: token.operationEntityID
        });

        setGroupDropDownData();
    }

    async function getDeductionTypesForTable() {
        const deductionTypeNames = await services.GetAllDedtuctionTypeNames();
        setDeductionTypeNamesOfTable(deductionTypeNames);
    }

    async function setGroupDropDownData() {
        const result = await services.getGroups()
        setGroups(result)
    }

    async function getEsatesForDropDown() {
        const factoryList = await services.getFactoryByGroupID(searchForm.groupID);
        setFactories(factoryList);
    }

    async function GetAllRoutesForDropDown() {
        const routeList = await services.GetAllRoutesByFactoryID(searchForm.factoryID);
        setRoutes(routeList);
    }

    function generateDropDownMenu(data) {
        let items = []
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(<MenuItem key={key} value={key}>{value}</MenuItem>)
            }
        }
        return items
    }

    function handleChange(e) {
        const target = e.target
        const value = target.name === 'active' ? target.checked : target.value

        const error = { ...errors }
        const errorMessage = validateProperty(target, DailyCollectionCategoryObject)
        errorMessage ? error[target.name] = errorMessage : delete error[target.name]

        setSearchForm({
            ...searchForm,
            [e.target.name]: value
        });
        setErrors(error);
        clearTableRelatedData();
    }

    async function handleSearch(e) {
        e.preventDefault();
        setIsTableHide(true);

        setSearchDataForPdf();

        const errorMessages = validate(schema, searchForm);
        errorMessages !== null ? setErrors(errorMessages) : setErrors({});
        if (errorMessages) return;

        var factoryWeighReportDetails = await services.getFactoryWeighReportDetails(searchForm);
        var collectionCategoryReportDetails = await services.searchCollectionCategoryroutes(searchForm);

        const feildDeductionTypes = await services.getFeildDeductionTypeNames(searchForm);
        const weighDeductionTypes = await services.getWeighDeductionTypeNames(searchForm);
        let weighDeductionTypesCopy = [...weighDeductionTypes];

        var deductionTypes = [...deductionTypeNamesOfTable];

        deductionTypes.forEach((val, index) => deductionTypes[index] = "f" + val);

        weighDeductionTypes.forEach((val, index) => weighDeductionTypes[index] = "f" + val.deductionTypeName);
        feildDeductionTypes.forEach((val, index) => feildDeductionTypes[index] = val.deductionTypeName);

        setFeildAvailabeDedauctionTypes(feildDeductionTypes);
        setWeighAvailabeDedauctionTypes(weighDeductionTypes);

        weighDeductionTypesCopy.forEach((val, index) => weighDeductionTypesCopy[index] = val.deductionTypeName);
        setWeighDedauctionTypesTable(weighDeductionTypesCopy);

        let groupedFactoryWeighResult = groupByTag(factoryWeighReportDetails);
        let factoryWeighKeys = Object.keys(groupedFactoryWeighResult);
        let factoryWeighArrayCollection = [];

        factoryWeighKeys.forEach(x => {
            var res = pivotFactoryWeighResult(groupedFactoryWeighResult[x]);
            factoryWeighArrayCollection.push(res);
        });

        let groupedResult = groupByMobileSession(collectionCategoryReportDetails);
        let keys = Object.keys(groupedResult);
        setMobileSessionKeys(keys);
        let arrayCollection = [];

        keys.forEach(x => {
            var res = pivotResultData(groupedResult[x]);
            arrayCollection.push(res);
        });

        let rowNames = initialContentRowNames;
        let csvHeaderNames = initlaCsvHeaders;

        if (permissionList.isActulaAmountColumnEnabled) {
            rowNames.splice(7, 0, "actualAmount");
            csvHeaderNames.splice(7, 0, { label: "Field Actual Amount", value: "actualAmount" });
            rowNames.splice(10, 0, "factualAmount");
            csvHeaderNames.splice(10, 0, { label: "Factory Actual Amount", value: "factualAmount" });
        }
        if (permissionList.isVarianceColumnEnabled) {
            rowNames.push("variance");
            csvHeaderNames.push({ label: "Variance", value: "variance" });
        }

        rowNames.splice((permissionList.isActulaAmountColumnEnabled ? 9 : 8), 0, ...feildDeductionTypes);
        rowNames.splice(((permissionList.isActulaAmountColumnEnabled ? 12 : 10) + feildDeductionTypes.length), 0, ...weighDeductionTypes);

        feildDeductionTypes.forEach((deductionType, index) => {
            csvHeaderNames.splice((9 + index), 0, { label: deductionType, value: deductionType });
        })

        weighDeductionTypes.forEach((deductionType, index) => {
            csvHeaderNames.splice((12 + feildDeductionTypes.length + index), 0, { label: `Factory ${deductionType.substring(1)}`, value: deductionType });
        })

        setContentRowNames(rowNames);
        setCsvHeaders(csvHeaderNames);

        for (let i = 0; i < arrayCollection.length; i++) {
            let feild = arrayCollection[i];

            if (feild.length > 0) {
                feild.forEach((f, index) => {
                    factoryWeighArrayCollection.forEach(x => {
                        if (f.tagNumber === x[0].ftagNumber &&
                            f.date === x[0].ffullTime) {

                            f.fGrossAmount = x[0].fGrossAmount;
                            f.fNetAmount = x[0].fNetAmount;
                            f.factualAmount = x[0].factualAmount;
                            f.fmobileSessionID = x[0].fmobileSessionID;
                            f.fsessionStartTime = x[0].fsessionStartTime;
                            f.fstartTime = x[0].fstartTime;
                            f.ftagNumber = x[0].ftagNumber;
                            f.variance = (parseFloat(x[0].factualAmount) - parseFloat(f.actualAmount)).toFixed(2);

                            var gainLossCal = (parseFloat(x[0].fGrossAmount) - parseFloat(f.grossAmount));

                            f.grossVariance = gainLossCal.toFixed(2);
                            f.lossGain =  gainLossCal > 0 ? "Gain" : (gainLossCal === 0 ? "-" : "Loss");

                            weighDeductionTypes.forEach(t => {
                                f[t] = x[0][t];
                            });
                        }
                    });
                });
            }
        }

        setFooterTotalRowExcel(generateFooterTotalRow(arrayCollection));

        if (arrayCollection.length > 0) {
            setIsReportButtonsEnabled(true);
        } else {
            setIsReportButtonsEnabled(false);
        }

        getSelectedDropdownValuesForReport(searchForm);

        setIsTableHide(false);

        setcollectionCategoryReport(arrayCollection);

        createSummeryCard(arrayCollection, [...feildDeductionTypes]);
    }

    function generateFooterTotalRow(data) {
        var totalRow = [];
        data.forEach(sessionData => {
            sessionData.forEach(y => {
                if (totalRow.length === 0) {
                    var newRecord = refactorFooterTotalRecord(y);
                    totalRow.push(newRecord);
                } else {

                    var duplicateRecord = totalRow.find(a => a.mobileSessionID === y.mobileSessionID);

                    if (duplicateRecord) {
                        for (const property in y) {
                            if (property !== "mobileSessionID") {
                                duplicateRecord[property] = checkUndifinedAndNaN(duplicateRecord[property]) + checkUndifinedAndNaN(y[property]);
                            }
                        }
                    } else {
                        var newRecord = refactorFooterTotalRecord(y);
                        totalRow.push(newRecord);
                    }
                }
            })
        });
        setTotalSummaryRow(totalRow);
        return totalRow;
    }

    function refactorFooterTotalRecord(y) {
        var newRecord = {}
        for (const property in y) {
            if (property === "mobileSessionID") {
                newRecord.mobileSessionID = y.mobileSessionID;
            }
            else {
                newRecord[property] = checkUndifinedAndNaN(y[property]);
            }
        }
        return newRecord;
    }

    function checkUndifinedAndNaN(value) {
        if (value === undefined || value === NaN) {
            return 0;
        } else {
            return parseFloat(value);
        }
    }

    function createSummeryCard(data, deductions) {

        var sumOfData = {
            gross: 0,
            net: 0,
            total: 0,
            bagCount: 0
        }
        var sumOfDecutions = {};
        var deductionNamesForSummary = [];
        var diffrentDeductionSum = {};

        deductions.forEach(x => {
            if (x.charAt(0) === 'f') {
                deductionNamesForSummary.push(x.substring(1))
            } else {
                deductionNamesForSummary.push(x)
            }
        })

        deductionNamesForSummary = [...new Set(deductionNamesForSummary)]

        data.forEach(x => {
            x.forEach(rec => {
                sumOfData.gross += (convertToFloat(rec.grossAmount));
                sumOfData.net += (convertToFloat(rec.netAmount));
                sumOfData.total += (convertToFloat(rec.actualAmount));
                sumOfData.bagCount += 1;

                deductions.forEach(d => {
                    if (sumOfDecutions[d] === undefined) {
                        sumOfDecutions[d] = convertToFloat(rec[d]);
                    } else {
                        sumOfDecutions[d] += convertToFloat(rec[d]);
                    }
                })
            });
        });

        deductionNamesForSummary.forEach(x => {
            for (const property in sumOfDecutions) {
                if (property === x) {
                    if (diffrentDeductionSum[x] === undefined) {
                        diffrentDeductionSum[x] = convertToFloat(sumOfDecutions[property])
                    } else {
                        diffrentDeductionSum[x] += convertToFloat(sumOfDecutions[property]);
                    }
                }
            }
        })

        for (const property in sumOfData) {
            if (property !== 'bagCount') {
                sumOfData[property] = sumOfData[property].toFixed(2)
            }
        }

        setDeductionNamesForSummary(deductionNamesForSummary);
        setDetailDeductions(diffrentDeductionSum);
        setDetailCard(sumOfData);
    }

    function convertToFloat(number) {
        if (number === undefined) {
            return 0;
        } else {
            return parseFloat(number);
        }
    }


    function roundNumbers(number) {
        return Math.round((number + Number.EPSILON) * 100) / 100
    }

    function createFile() {
        var settings = {
            sheetName: 'Daily Collection Detailed',
            fileName: 'DailyCollectionDetailedReport',
            writeOptions: {}
        }

        var result = createDataForExcel(collectionCategoryReport, footerTotalRowExcel);

        result.push({}, {
            customerFullName: "Group: " + selectedSearchValues.group,
            date: "Factory: " + selectedSearchValues.factory,
            startTime: "Route: " + selectedSearchValues.route,
            collectionTypeName: "From Date: " + selectedSearchValues.date,
            tagNumber: "To Date: " + selectedSearchValues.toDate,
        })

        xlsx(csvHeaders, result, settings, true)
    }

    function setSearchDataForPdf() {
        setSelectedSearchValues({
            ...selectedSearchValues,
            group: groups[searchForm.groupID],
            route: routes[searchForm.routeID],
            factory: factories[searchForm.routeID],
            searchdate: searchForm.searchdate,
            toDate: searchForm.toDate
        })
    }

    function createDataForExcel(array, footerTotalRow) {
        var res = [];

        array.forEach((x, a) => {
            var matchedTotalRow = footerTotalRow.find(z => z.mobileSessionID === x[0].mobileSessionID);
            var firstRow = [];
            var sessionviseData = [];

            x.forEach((y, i) => {
                if (i === 0) {
                    firstRow.push({},
                        {
                            customerFullName: "Session Start Date: " + y.sessionStartDate,
                            date: "Session Start Time: " + y.sessionStartTime
                        }, {});
                }
                sessionviseData.push(y);
            });

            sessionviseData.sort((a, b) => a.date.localeCompare(b.date) || a.startTime.localeCompare(b.startTime));

            if (matchedTotalRow) {
                var newSubTotalRow = { customerFullName: "Total" };

                for (var prop in matchedTotalRow) {
                    if (prop !== "customerFullName" && prop !== "date" && prop !== "registrationNumber"
                        && prop !== "startTime" && prop !== "collectionTypeName" && prop !== "tagNumber"
                        && prop !== "narration" && prop !== "lossGain") {
                        newSubTotalRow[prop] = parseFloat(matchedTotalRow[prop]).toFixed(2);
                    }
                }

                sessionviseData.push(newSubTotalRow);
            }
            sessionviseData.unshift(...firstRow);
            res.push(...sessionviseData);
        })
        setExcelData(res);
        return res;
    }

    function getSelectedDropdownValuesForReport(searchForm) {
        setSelectedSearchValues({
            ...selectedSearchValues,
            group: groups[searchForm.groupID],
            factory: factories[searchForm.factoryID],
            route: routes[searchForm.routeID],
            date: searchForm.searchdate,
            toDate: searchForm.toDate
        })
    }

    function groupByMobileSession(objectArray) {
        return objectArray.reduce(function (acc, obj) {
            let key = obj['mobileSessionID']
            if (!acc[key]) {
                acc[key] = []
            }
            acc[key].push(obj)
            return acc
        }, {})
    }

    function groupByTag(objectArray) {
        return objectArray.reduce(function (acc, obj) {
            let key = obj['tagNumber'] +"-"+obj['startTime'].split("T")[0];

            if (!acc[key]) {
                acc[key] = []
            }
            acc[key].push(obj)
            return acc
        }, {})
    }

    const convertFrom24To12Format = (time24) => {
        var timeSplit = time24.split(":");
        return timeSplit[0] + ":" + timeSplit[1];
    }

    function pivotResultData(data) {
        var result = [];
        data.forEach(function (e) {
            var a = e.tagNumber;

            if (!this[a]) {

                let time = convertFrom24To12Format(e.startTime.split('T')[1].split('.')[0]);

                let sessiontime = convertFrom24To12Format(e.sessionStartTime.split('T')[1].split('.')[0]);

                this[a] = {
                    actualAmount: e.actualAmount.toFixed(2),
                    collectionTypeName: e.collectionTypeName,
                    customerFullName: e.customerFullName,
                    tagNumber: e.tagNumber,
                    registrationNumber: e.registrationNumber,
                    narration: e.narration,
                    startTime: time,
                    date: e.startTime.split('T')[0],
                    fullTime: e.startTime.split('T')[0],
                    netAmount: e.netAmount.toFixed(2),
                    grossAmount: e.grossAmount.toFixed(2),
                    mobileSessionID: e.mobileSessionID,
                    sessionStartTime: sessiontime,
                    sessionStartDate: e.sessionStartTime.split('T')[0]
                }
                result.push(this[a]);
            }
            this[a][e.deductionTypeName] = e.totalDeduction.toFixed(2);

        }, {});
        return result;
    }

    function pivotFactoryWeighResult(data) {
        var result = [];
        data.forEach(function (e) {
            var a = e.tagNumber;

            if (!this[a]) {
                let time = convertFrom24To12Format(e.startTime.split('T')[1].split('.')[0]);

                this[a] = {
                    factualAmount: e.fActualAmount.toFixed(2),
                    ftagNumber: e.tagNumber,
                    fstartTime: time,
                    ffullTime: e.startTime.split('T')[0],
                    fNetAmount: e.fNetAmount.toFixed(2),
                    fGrossAmount: e.fGrossAmount.toFixed(2),
                }
                result.push(this[a]);
            }
            this[a]["f" + e.fDeductionTypeName] = e.fTotalDeduction.toFixed(2);

        }, {});
        return result;
    }

    function destroyDataTable() {
        collectionCategoryReport.forEach(e => {
            $(`#${e[0].mobileSessionID}`).DataTable().destroy();
            $(`#${e[0].mobileSessionID}_Pdf`).DataTable().destroy();
        });
    }

    function createDataTable() {
        collectionCategoryReport.forEach(e => {
            $(`#${e[0].mobileSessionID}`).DataTable({
                "order": [[1, "asc"], [2, "asc"]]
            });
            $(`#${e[0].mobileSessionID}_Pdf`).DataTable({
                paging: false,
                "order": [[1, "asc"], [2, "asc"]]
            });
        });
    }

    function onCancelClick() {
        setSearchForm({
            ...searchForm,
            routeID: "0",
            searchdate: '',
            toDate: '',
        });
        clearTableRelatedData();
    }

    function clearTableRelatedData() {
        setcollectionCategoryReport([]);
        setWeighDedauctionTypesTable([]);
        setFeildAvailabeDedauctionTypes([]);
        setWeighAvailabeDedauctionTypes([]);
        setIsTableHide(true);
        setSelectedSearchValues([]);
    }

    function generateTotalRow(mobileSessionID) {

        var result = totalSummaryRow.find(x => x.mobileSessionID === mobileSessionID);

        var tempRes = [];

        contentRowNames.forEach((x, i) => {
            if (i > 6) {
                for (var prop in result) {
                    if (prop === x) {
                        tempRes.push({ name: prop, value: result[prop] });
                    }
                }
            }
        });

        if (result) {
            return (
                <tr>
                    <th colSpan="7">Total</th>
                    {
                        tempRes.map((x, i) => {
                            if (x.name === "lossGain") {
                                return (<th key={i}></th>)
                            } else {
                                return (<th key={i} style={{ textAlign: "right" }}>{x.value.toFixed(2)}</th>)
                            }
                        })
                    }
                </tr>
            );
        }
    }

    return (
        <Fragment>
            <LoadingSpinerComponent />

            <div className="row">
                <div className="col-md-12">
                    <div className="card" >
                        <div ref={pdfRef} className="card-body">
                            <div className="row">
                                <PageHeader
                                    title="Daily Collection Detailed Report"
                                />
                            </div>
                            <form onSubmit={(e) => trackPromise(handleSearch(e))}>
                                <div className="form-group row">
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="groupID">Group *</InputLabel>
                                        <Select
                                            fullWidth
                                            id="groupID"
                                            disabled={!permissionList.isGroupFilterEnabled}
                                            name="groupID"
                                            value={searchForm.groupID}
                                            onChange={(e) => handleChange(e)}>
                                            <MenuItem value="0">--Select Group--</MenuItem>
                                            {generateDropDownMenu(groups)}
                                        </Select>
                                        {errors["groupID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["groupID"]}</FormHelperText>}
                                    </div>
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="factoryID">Factory *</InputLabel>
                                        <Select fullWidth
                                            id="factoryID"
                                            disabled={!permissionList.isOperationEntityFilterEnabled}
                                            name="factoryID"
                                            value={searchForm.factoryID}
                                            onChange={(e) => handleChange(e)}>
                                            <MenuItem value="0">--Select factory--</MenuItem>
                                            {generateDropDownMenu(factories)}
                                        </Select>
                                        {errors["factoryID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["factoryID"]}</FormHelperText>}
                                    </div>
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="routeID">Route *</InputLabel>
                                        <Select fullWidth
                                            id="routeID"
                                            name="routeID"
                                            value={searchForm.routeID}
                                            onChange={(e) => handleChange(e)}>
                                            <MenuItem value="0">--Select route--</MenuItem>
                                            {generateDropDownMenu(routes)}
                                        </Select>
                                        {errors["routeID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["routeID"]}</FormHelperText>}
                                    </div>
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="searchdate">From *</InputLabel>
                                        <TextField
                                            fullWidth
                                            id="searchdate"
                                            name="searchdate"
                                            type="date"
                                            value={searchForm.searchdate}
                                            onInput={(e) => handleChange(e)}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                        />
                                    </div>
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="toDate">To *</InputLabel>
                                        <TextField
                                            fullWidth
                                            id="toDate"
                                            name="toDate"
                                            value={searchForm.toDate}
                                            type="date"
                                            onInput={(e) => handleChange(e)}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                        />
                                    </div>
                                </div>
                                <input
                                    type="submit"
                                    className="btn btn-primary"
                                    disabled={validate(schema, searchForm)}
                                    value="Generate"
                                />
                                <input type="reset"
                                    className="btn btn-warning pull-right"
                                    value="Clear"
                                    onClick={onCancelClick}
                                />
                            </form>
                            {isTableHide ? null :
                                <div>
                                    <div className="card" style={{ maxWidth: "1400px" }}>
                                        <div className="card-header"><h5>Field Summary</h5></div>
                                        <div className="card-body">
                                            {permissionList.isActulaAmountColumnEnabled ?
                                                <p className="d-inline pr-3"><b>Actual Amount : </b> {detailCard.total} Kg</p>
                                                : null
                                            }
                                            <p className="d-inline pr-3"><b>Gross Amount : </b>{detailCard.gross} Kg</p>
                                            <p className="d-inline pr-3"><b>Net Amount : </b>{detailCard.net} Kg</p>
                                            <p className="d-inline pr-3"><b>Bag Count : </b>{detailCard.bagCount}</p>
                                            {deductionNamesForSummary.map((d, i) => {
                                                return (
                                                    <p key={i} className="pt-3 d-inline pr-3"><b>{d} : </b>{roundNumbers(detailDeductions[d])} Kg</p>
                                                )
                                            })}
                                        </div>
                                    </div>

                                    {collectionCategoryReport.map((e, index) => {
                                        return (
                                            <div className="row" key={index}>
                                                <div className="col-md-12">
                                                    <div key={index} className="card shadow-none bg-light">
                                                        <div className="card-body">
                                                            <p><b>Session start date: {e[0].sessionStartDate}</b></p>
                                                            <p><b>Session start time: {e[0].sessionStartTime}</b></p>
                                                            <div>
                                                                <table
                                                                    id={e[0].mobileSessionID}
                                                                    style={{
                                                                        display: "block", overflowX: "auto", whiteSpace: "nowrap"
                                                                        , maxWidth: "1300px", borderColor: "white"
                                                                    }}>
                                                                    <thead>
                                                                        <tr>
                                                                            <th rowSpan="2">Customer Name</th>
                                                                            <th rowSpan="2">Date</th>
                                                                            <th rowSpan="2">Time</th>
                                                                            <th rowSpan="2">Collection Type</th>
                                                                            <th rowSpan="2">Tag Number</th>
                                                                            <th rowSpan="2">Registration Number</th>
                                                                            <th rowSpan="2">Narration</th>
                                                                            <th bgcolor="#82E0AA" colSpan={feildAvailabeDedauctionTypes.length + (permissionList.isActulaAmountColumnEnabled ? 3 : 2)}
                                                                                scope="colgroup">Field</th>
                                                                            <th bgcolor="#DAF7A6" colSpan={weighAvailabeDedauctionTypes.length + (permissionList.isActulaAmountColumnEnabled ? 3 : 2)}
                                                                                scope="colgroup">Factory Weigh</th>
                                                                            <th rowSpan="2">Gross Variance (Kg)</th>
                                                                            <th rowSpan="2">Loss/Gain</th>
                                                                        </tr>
                                                                        <tr>
                                                                            {permissionList.isActulaAmountColumnEnabled ?
                                                                                <th scope="col">Actual Amount (Kg)</th> : null
                                                                            }
                                                                            <th scope="col">Gross Amount (Kg)</th>
                                                                            {feildAvailabeDedauctionTypes.map((data, index) => {
                                                                                return (
                                                                                    <th scope="col" key={index}>{data}</th>
                                                                                );
                                                                            })}
                                                                            <th scope="col">Net Amount (Kg)</th>
                                                                            {permissionList.isActulaAmountColumnEnabled ?
                                                                                <th scope="col">Actual Amount (Kg)</th> : null
                                                                            }
                                                                            <th scope="col">Gross Amount (Kg)</th>
                                                                            {weighDedauctionTypesTable.map((data, index) => {
                                                                                return (
                                                                                    <th scope="col" key={index}>{data}</th>
                                                                                );
                                                                            })}
                                                                            <th scope="col">Net Amount (Kg)</th>
                                                                            {
                                                                                permissionList.isVarianceColumnEnabled ?
                                                                                    <th scope="col">Actual Variance (Kg)</th> : null
                                                                            }
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        <DailyCollectionReportContent
                                                                            data={e}
                                                                            contentRowNames={contentRowNames}
                                                                            hasEdit={false}
                                                                        />
                                                                    </tbody>
                                                                    <tfoot>
                                                                        {generateTotalRow(e[0].mobileSessionID)}
                                                                    </tfoot>
                                                                </table>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        )
                                    })}

                                    {!isReportButtonsEnabled ? <div></div> :
                                        <div className="pt-2">
                                            <ReactToPrint
                                                documentTitle={"Daily Collection Detailed Report"}
                                                trigger={() => <input
                                                    type="button"
                                                    className="btn btn-primary pull-right ml-2"
                                                    value="Create PDF"
                                                />}
                                                content={() => componentRef.current}
                                            />
                                            <div hidden={true}>
                                                <CreatePdf ref={componentRef} data={collectionCategoryReport}
                                                    rowNames={contentRowNames} searchData={selectedSearchValues} totalSummaryRow={totalSummaryRow}
                                                    permission={permissionList} feildAvailabeDedauctionTypes={feildAvailabeDedauctionTypes}
                                                    weighDedauctionTypesTable={weighDedauctionTypesTable} weighAvailabeDedauctionTypes={weighAvailabeDedauctionTypes} />
                                            </div>
                                            <input
                                                type="button"
                                                className="btn btn-primary pull-right ml-2"
                                                value="Excel"
                                                onClick={createFile}
                                            />
                                        </div>}
                                </div>

                            }


                        </div>
                    </div>
                </div>
            </div>

        </Fragment>
    )
}


